/** Showroom location — Naguanagua, Carabobo, Venezuela */
export const siteLocation = {
  addressLine1: "Av. Universidad con Calle 139",
  addressLine2: "Naguanagua 2005, Carabobo, Venezuela",
  addressFull:
    "Av. Universidad con Calle 139, Naguanagua 2005, Carabobo, Venezuela",
  city: "Naguanagua",
  region: "Carabobo",
  country: "Venezuela",
  phoneDisplay: "+58 241-555-0188",
  phoneTel: "+582415550188",
  whatsapp: "582415550188",
  email: "concierge@meridianmotors.com",
  /** Approx. center of Naguanagua */
  lat: 10.2511,
  lon: -68.0078,
  /** OpenStreetMap embed bbox: west,south,east,north */
  mapEmbedUrl:
    "https://www.openstreetmap.org/export/embed.html?bbox=-68.0278%2C10.2361%2C-67.9878%2C10.2661&layer=mapnik&marker=10.2511%2C-68.0078",
} as const;
